module.exports = __webpack_public_path__ + "static/media/lt_lt.62fce88d.png";